import { type } from "@testing-library/user-event/dist/type";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useJWT from "../../hooks/useJWT";
import useCart from "../../hooks/useCart";
import useCheckout from "../../hooks/useCheckout";
import useShipment from "../../hooks/useShipment";
import useSingleInvoice from "../../hooks/useSingleInvoice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Accordion from "react-bootstrap/Accordion";
import ModalGlobal from "../global/ModalGlobal";
import useBank from "../../hooks/useBank";
import useAddress from "../../hooks/useAddress";
import useLocation from "../../hooks/useLocation";
import { data } from "isotope-layout";
import { useAppConfig } from "../../context/AppConfigContext";
import { isEmptyObject } from "jquery";
import {
  formatCurrencyLocal,
  formatNumberLocal,
} from "../../utils/stringManipulator";

const OrderDetail = ({ dataInvoice }) => {
  const { config } = useAppConfig();
  const { user } = useJWT();
  const navigate = useNavigate();
  //console.log(dataInvoice);

  // get query params id from url
  const queryParams = new URLSearchParams(window.location.search);
  const invoiceId = queryParams.get("id");

  const [selectedShipmentData, setSelectedShipmentData] = useState(null);
  const [selectedShipmentDetailData, setSelectedShipmentDetailData] =
    useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState(0);
  const [selectedPayment, setSelectedPayment] = useState(1);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [show, setShow] = useState(false);

  const [orderSubtotal, setOrderSubtotal] = useState(0);
  const [orderShipping, setOrderShipping] = useState(0);
  const [orderTotal, setOrderTotal] = useState(0);
  const lastFetchedLocationIdRef = React.useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { fetchActiveShipment, data: shipmentData } = useShipment();

  const { fetchSingleInvoice, data: singleInvoice } = useSingleInvoice();

  const statusColor =
    singleInvoice?.status === 2 ||
    singleInvoice?.status === 3 ||
    singleInvoice?.status === 6
      ? "#299E60"
      : singleInvoice?.status === 1
        ? "#df5454"
        : singleInvoice?.status === 0 ||
            singleInvoice?.status === 4 ||
            singleInvoice?.status === 5
          ? "#ebc856"
          : "#d3eb56";

  const {
    fetchSingleAddress,
    single: singleAddress,
    status: addressStatus,
  } = useAddress();

  const {
    fetchLocationList,
    fetchLocationDetails,
    data: locationData,
    single: locationSingle,
  } = useLocation();

  useEffect(() => {
    if (invoiceId) {
      fetchSingleInvoice(invoiceId);
      fetchActiveShipment();
      // fetchSingleAddress(dataInvoice?.addressId);
      // const prodTotal = dataInvoice?.details
      //   .reduce(
      //     (total, item) => total + (item?.price * item?.qty || 0),
      //     0
      //   );
      // setOrderSubtotal(prodTotal);
      // setOrderTotal(prodTotal + dataInvoice?.shippingCost);
      // setOrderShipping(dataInvoice?.shippingCost);
    }
  }, [invoiceId]);

  useEffect(() => {
    if (!isEmptyObject(singleInvoice)) {
      fetchSingleAddress(singleInvoice?.addressId);
      const prodTotal = singleInvoice?.details.reduce(
        (total, item) => total + (item?.price * item?.qty || 0),
        0,
      );
      setOrderSubtotal(prodTotal);
      setOrderTotal(prodTotal + singleInvoice?.shippingCost);
      setOrderShipping(singleInvoice?.shippingCost);
    }
  }, [singleInvoice]);

  useEffect(() => {
    if (isEmptyObject(singleInvoice)) {
      return;
    }

    const payload = {
      skip: 0,
      take: 1,
      filter: "",
      startDate: null,
      endDate: null,
      quickFilter: [],
      sort: [],
      isActive: true,
      orderFulfillment: true,
    };

    fetchLocationList(payload);
  }, [fetchLocationList, singleInvoice]);

  useEffect(() => {
    const targetId = locationData?.list?.[0]?.id;

    if (!targetId || lastFetchedLocationIdRef.current === targetId) {
      return;
    }

    lastFetchedLocationIdRef.current = targetId;
    fetchLocationDetails(targetId);
  }, [fetchLocationDetails, locationData]);

  // useEffect(() => {
  //   if (data) {
  //     const prodTotal = data
  //       .reduce(
  //         (total, item) => total + (item?.price * item?.qty || 0),
  //         0
  //       );
  //     setOrderSubtotal(prodTotal);
  //     setOrderTotal(prodTotal + orderShipping);
  //   }
  // }, [data, orderShipping]);

  // useEffect(() => {
  //   if (addressStatus === "done") {
  //     if(address && address.length > 0) {
  //       const isPrimaryAddress = address.find((address) => address.isPrimary);
  //       if (isPrimaryAddress) {
  //         onSelectAddress(isPrimaryAddress);
  //       }
  //     }
  //   }
  // }, [addressStatus, address]);

  return (
    <>
      <section className="checkout py-80">
        <div className="container container-md">
          <div
            className=" rounded-top px-30 py-20"
            style={{ backgroundColor: statusColor }}
          >
            <h6 className="text-xl text-white mb-0">
              {singleInvoice?.status === 4
                ? "To Shipping"
                : singleInvoice?.status === 5
                  ? "On Delivery"
                  : singleInvoice?.statusName}
            </h6>
          </div>
          <button className="border border-gray-100 px-30 py-20 w-100">
            {shipmentData &&
              shipmentData.length > 0 &&
              shipmentData
                .filter(
                  (item) => item.id === singleInvoice?.expeditionSettingId,
                )
                .map((shipment, index) => (
                  <div
                    className="d-block d-lg-flex align-items-center justify-content-between"
                    key={index}
                  >
                    <div className="">
                      <div className="d-flex align-items-center gap-16">
                        <h6 className="text-xl mb-8">
                          {"Delivery Information"}
                        </h6>
                      </div>
                      <div className="d-flex align-items-center gap-16 mb-16">
                        <h6 className="text-sm text-gray-600 fw-medium mb-8">
                          {shipment?.name ?? ""}:{" "}
                          {shipment?.details.find(
                            (item) =>
                              item.id ===
                              singleInvoice?.expeditionSettingDetailId,
                          )?.name ?? ""}
                        </h6>
                      </div>
                      <div className="d-flex align-items-start gap-16">
                        <i className="ph ph-truck text-gray-600 mt-2" />
                        <div className="text-start">
                          <h6 className="text-md text-main-600 mb-8">
                            {singleInvoice?.status === 4
                              ? "To Shipping"
                              : singleInvoice?.status === 5
                                ? "On Delivery"
                                : singleInvoice?.status === 6
                                  ? "Completed"
                                  : "To Shipping"}
                          </h6>
                          <span className="text-start text-sm text-gray-600">
                            {singleInvoice?.deliveryDate !== null
                              ? new Date(
                                  singleInvoice?.deliveryDate,
                                ).toLocaleDateString()
                              : "-"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* <div className="d-flex align-items-center text-main-one-600">
                    <span className="text-decoration-underline me-5">
                      Change Address
                    </span>
                    <i className="ph ph-caret-right" />
                  </div> */}
                  </div>
                ))}
          </button>
          <button className="border border-gray-100 px-30 py-20 w-100">
            <div className="d-block d-lg-flex align-items-center justify-content-between">
              <div className="">
                <div className="d-flex align-items-center gap-16">
                  <h6 className="text-xl mb-8">{"Pickup Address"}</h6>
                </div>
                <div className="d-flex align-items-center gap-16 mb-16">
                  <h6 className="text-sm text-gray-600 fw-medium mb-8">
                    {locationSingle?.name || "Location Name"}
                  </h6>
                </div>
                <div className="d-flex align-items-start gap-16">
                  <i className="ph ph-map-pin text-gray-600 mt-4" />
                  <div className="text-start">
                    <span className="text-start text-sm text-gray-600">
                      {locationSingle?.streetName || locationSingle?.address ||
                        locationSingle?.otherDetail ||
                        locationSingle?.province ||
                        locationSingle?.city
                        ? [
                            locationSingle?.streetName,
                            locationSingle?.address,
                            locationSingle?.otherDetail,
                            locationSingle?.province,
                            locationSingle?.city,
                            locationSingle?.postalCode,
                          ]
                            .filter(Boolean)
                            .join(", ")
                        : "Location Address, Street Name, Province, City"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </button>
          <button className="border border-gray-100 rounded-bottom px-30 py-20 mb-40 w-100">
            <div className="d-block d-lg-flex align-items-center justify-content-between">
              <div className="">
                <div className="d-flex align-items-center gap-16 mb-16">
                  <h6 className="text-xl mb-8">{"Delivery Address"}</h6>
                </div>
                <div className="d-flex align-items-start gap-16">
                  <i className="ph ph-map-pin text-gray-600 mt-4" />
                  <div className="text-start">
                    <div className="d-flex align-items-center gap-16">
                      <h6 className="text-xl mb-8">
                        {singleAddress?.name ?? "No Address Selected"}
                      </h6>
                      <span className="text-sm text-gray-600 mb-8">
                        {singleAddress?.phoneNumber}
                      </span>
                    </div>
                    <div className="d-block d-lg-flex align-items-center justify-content-start gap-16">
                      <span className="text-start">
                        {singleAddress?.province
                          ? `${singleAddress?.province}, `
                          : ""}
                        {singleAddress?.streetName
                          ? `${singleAddress?.streetName}, `
                          : ""}
                        {singleAddress?.otherDetail
                          ? `${singleAddress?.otherDetail}`
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="d-flex align-items-center text-main-one-600">
                <span className="text-decoration-underline me-5">
                  Change Address
                </span>
                <i className="ph ph-caret-right" />
              </div> */}
            </div>
          </button>

          <div className="border border-gray-100 rounded-top px-30 py-20 w-100">
            <div className="d-block d-lg-flex w-100 align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-16">
                <h6 className="text-xl fw-bold mb-8">Order</h6>
              </div>
            </div>
            {!isEmptyObject(singleInvoice) &&
              singleInvoice.details.map((item, key) => (
                <div
                  className="d-flex align-items-center justify-content-between mt-16"
                  key={key}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-16">
                    <img
                      src={
                        item.photoData[0]?.url ||
                        "assets/images/thumbs/product-details-thumb1.png"
                      }
                      alt=""
                      className="img-fluid"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        padding: "20px",
                        border: "1px solid #f1f1f1",
                        borderRadius: "8px",
                      }}
                    />
                    <div style={{ textWrapStyle: "balance" }}>
                      <h6 className="text-xl fw-bold mb-8">
                        {item.productName}
                      </h6>
                      <span className="text-sm text-gray-600 mb-8">
                        {item.variantCombinationName}
                      </span>
                    </div>
                  </div>
                  <div className="text-end" style={{ minWidth: "150px" }}>
                    <h6 className="text-xl fw-bold mb-8">
                      x {formatNumberLocal(item.qty)}
                    </h6>
                    <div className="d-flex justify-content-end align-items-center gap-16">
                      {/* <h6
                      className="text-sm text-gray-600 text-decoration-line-through mb-8"
                      style={{ textDecorationStyle: "dashed" }}
                    >
                      ${item.price.toFixed(2)}
                    </h6> */}
                      <span className="text-sm fw-bold text-black mb-8">
                        {formatCurrencyLocal(item.price, config?.currency)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="border border-gray-100 rounded-bottom px-24 py-40 w-100">
            <div className="mb-0 flex-between gap-8">
              <span className="text-gray-900 font-heading-one text-md fw-normal">
                Order Subtotal
              </span>
              <span className="text-gray-900 font-heading-one text-md fw-normal">
                {formatCurrencyLocal(orderSubtotal, config?.currency)}
              </span>
            </div>
            <div className="mb-0 flex-between gap-8">
              <span className="text-gray-900 font-heading-one text-md fw-normal">
                Delivery Fee
              </span>
              <span className="text-gray-900 font-heading-one text-md fw-normal">
                {formatCurrencyLocal(orderShipping, config?.currency)}
              </span>
            </div>
            {/* <div className="mb-0 flex-between gap-8">
              <span className="text-gray-900 font-heading-one text-md fw-normal">
                Delivery Discount
              </span>
              <span className="text-gray-900 font-heading-one text-md fw-normal">
                {"$0.00"}
              </span>
            </div> */}
            <div className="d-flex mt-22 pt-22 border-top border-gray-100 align-items-center justify-content-end mt-16">
              <div className="d-flex align-items-center gap-16">
                <h6 className="text-xl fw-bold mb-8">Total</h6>
                <span className="text-xl fw-bold text-black mb-8">
                  {formatCurrencyLocal(orderTotal, config?.currency)}
                  {/* ${singleInvoice.totalPayment.toFixed(2)} */}
                </span>
              </div>
            </div>
          </div>

          <div className="border border-gray-100 rounded-8 px-24 py-40 mt-32">
            <div className="">
              <div className="d-block d-lg-flex align-items-center justify-content-between mb-8">
                <h6 className="text-xl mb-24">Order Number</h6>
                <h6 className="text-md text-gray-600 fw-medium mb-24">
                  {singleInvoice?.invoiceNumber}
                </h6>
              </div>
              <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Payment Method
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {singleInvoice?.paymentMethod === 0
                    ? "Bank Transfer"
                    : "Online Payment"}
                </span>
              </div>
              {/* <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Invoice
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  -
                </span>
              </div> */}
              <div className="mt-22 pt-22 border-top border-gray-100 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Order Time
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {new Date(singleInvoice?.createdDate).toLocaleDateString()}
                </span>
              </div>
              <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Payment Time
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {singleInvoice?.paymentConfirmDate !== null
                    ? new Date(
                        singleInvoice?.paymentConfirmDate,
                      ).toLocaleDateString()
                    : "-"}
                </span>
              </div>
              <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Delivery Number
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {singleInvoice?.deliveryNumber ?? "-"}
                </span>
              </div>
              <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Delivery Time
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {singleInvoice?.deliveryDate !== null
                    ? new Date(singleInvoice?.deliveryDate).toLocaleDateString()
                    : "-"}
                </span>
              </div>
              <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Order Finished Time
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {singleInvoice?.completeDate !== null
                    ? new Date(singleInvoice?.completeDate).toLocaleDateString()
                    : "-"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OrderDetail;
